"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const sliceReview_1 = require("../../../slice/sliceReview");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const ConfirmationModal = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleClickNext = () => {
        dispatch((0, sliceReview_1.nextModal)());
    };
    const handleCloseModal = () => {
        dispatch((0, sliceReview_1.closeModal)());
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['new-review-round'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['new-review-round__content'] },
            react_1.default.createElement("p", { className: styles_modules_less_1.default['new-review-round__content--title'] }, "Are you sure you want to start a new 'Round' of review?"),
            react_1.default.createElement("p", { className: styles_modules_less_1.default['new-review-round__content--text'] }, "If you start a new round of review, the current 'Round' will be finalised and no further comments or feedback will be accepted.")),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['new-review-round__actions'] },
            react_1.default.createElement("p", { className: styles_modules_less_1.default['new-review-round__actions--confirm'] }, "Do you wish to proceed?"),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['new-review-round__actions--buttons'] },
                react_1.default.createElement(pulse_components_1.PulseButton, { classes: [
                        (0, clsx_1.default)(styles_modules_less_1.default['custom-button'], styles_modules_less_1.default['custom-cancel-button']),
                    ], label: "Cancel", onClick: handleCloseModal }),
                react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default['custom-button']], color: pulse_components_1.Colors.success, icon: true, iconClasses: {
                        icon: 'fal fa-share-alt',
                    }, label: "Create new round", onClick: handleClickNext })))));
};
exports.default = ConfirmationModal;
